import { ChangeDetectionStrategy, Component, computed, input, linkedSignal, output } from '@angular/core';
import { FilterOptionComponent } from 'src/app/shared/ui/atoms/filter-option/filter-option.component';

// 'check': opciones de texto libre (label = value). 'bool': true/false renderizadas como 'Si'/'No'.
export type FilterOptionGroupMode = 'check' | 'bool';

interface FilterOptionEntry {
  label: string;
  value: string;
}

@Component({
  selector: 'app-filter-option-group',
  imports: [FilterOptionComponent],
  template: `
    <div class="filter-option-group">
      @for (opt of entries(); track opt.value) {
        <app-filter-option
          [label]="opt.label"
          [value]="opt.value"
          [active]="opt.value === selected()"
          (selected)="handleSelected($event)" />
      }
      <app-filter-option
        label="Todas"
        value="todas"
        [active]="selected() === 'todas'"
        (selected)="handleSelected($event)" />
    </div>
  `,
  styleUrl: './filter-option-group.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterOptionGroupComponent {
  readonly options = input<ReadonlyArray<string | boolean>>([]);
  readonly mode = input<FilterOptionGroupMode>('check');
  readonly initialValue = input('todas');
  // Al cambiar (boton 'Limpiar filtros') vuelve a la opcion inicial ('Todas') aunque la vista se reutilice.
  readonly resetKey = input(0);

  readonly optionSelected = output<string>();

  private readonly touchedValue = linkedSignal<number, string | null>({
    source: this.resetKey,
    computation: () => null,
  });

  readonly selected = computed(() => this.touchedValue() ?? this.initialValue());

  readonly entries = computed<FilterOptionEntry[]>(() =>
    this.options().map(opt => this.mode() === 'bool'
      ? { label: opt ? 'Si' : 'No', value: String(opt) }
      : { label: String(opt), value: String(opt) })
  );

  handleSelected(value: string): void {
    this.touchedValue.set(value);
    this.optionSelected.emit(value);
  }
}
